export function calcularTarifaMediaLiquidaBruta(item) {
    let tarifaMediaLiquida = 0;
    let tarifaMediaBruta = 0;

    const valorFatura = parseFloat(item.valor_fatura || 0);
    const qtdConsumoTotal = parseFloat(item.energia || 0);
    const somaValorDemandas = parseFloat(item.valor_demanda || 0) + parseFloat(item.valor_demanda_ponta || 0) + parseFloat(item.valor_demanda_geracao || 0);
    const somaDemandasComplementares = parseFloat(item.gasto_demanda_complementar || 0) + parseFloat(item.gasto_demanda_complementar_ponta || 0);
    const somaDemandasUltrapassagens =
        parseFloat(item.gasto_demanda_ultrapassagem || 0) + parseFloat(item.gasto_demanda_ultrapassagem_ponta || 0) + parseFloat(item.gasto_demanda_ultrapassagem_geracao || 0);
    const valorMulta = parseFloat(item.gasto_reativo || 0) + somaDemandasComplementares + somaDemandasUltrapassagens;
    if (qtdConsumoTotal != 0) {
        tarifaMediaLiquida = (valorFatura - valorMulta - somaValorDemandas) / qtdConsumoTotal;
        tarifaMediaBruta = valorFatura / qtdConsumoTotal;

        //troca possível valor negativo por zero
        tarifaMediaLiquida = tarifaMediaLiquida < 0 ? 0 : tarifaMediaLiquida.toFixed(2);
        tarifaMediaBruta = tarifaMediaBruta < 0 ? 0 : tarifaMediaBruta.toFixed(2);
    }
    return { tarifaMediaLiquida, tarifaMediaBruta };
}
